export default {
    props: {
        popupAppendTo: {
            type: String,
            default: undefined,
            kComposite: 'popup.appendTo'
        }, 
        popupOrigin: {
            type: String,
            default: undefined,
            kComposite: 'popup.origin'
        }, 
        popupPosition: {
            type: String,
            default: undefined,
            kComposite: 'popup.position'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/Common/Popup.js